export class InvestorApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getInvestors() {
    return this.#http.get('/Investor');
  }

  async getInvestorsList(params) {
    return this.#http.get('/Investor/list', { params });
  }

  async createInvestor(body) {
    return this.#http.post('/Investor', body);
  }

  async editInvestor({ investorId, ...body }) {
    return this.#http.put(`/Investor/${investorId}`, body);
  }

  async deleteInvestor(params) {
    return this.#http.delete(`/Investor`, { params });
  }
}
